(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jj-cancel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('jj-cancel-member-only')) return;

    class JJCancelMemberOnly extends HTMLElement {
      connectedCallback() {
        if (window.Shopify?.designMode) {
          this.hidden = false;
          return;
        }
        let cfg = null;
        try {
          const json = document.getElementById('jj-vip-config')?.textContent;
          cfg = json ? JSON.parse(json) : null;
        } catch (error) {
          cfg = null;
        }
        this.hidden = cfg?.customerIsMember !== true;
      }
    }

    customElements.define('jj-cancel-member-only', JJCancelMemberOnly);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-membership-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('jj-membership-card')) return;

    // Same wording as the cart checkbox (jj-vip.js) and STRUCTURE.md §4: "October 25, 2026".
    const formatDate = (date) =>
      date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

    // window.JJVip.config is the parsed #jj-vip-config (assets/jj-vip.js); read the JSON directly while
    // that module has not run yet.
    const readVipConfig = () => {
      if (window.JJVip?.config) return window.JJVip.config;
      try {
        const json = document.getElementById('jj-vip-config')?.textContent;
        return json ? JSON.parse(json) : null;
      } catch (error) {
        return null;
      }
    };

    // The cart right after /cart/add.js without another request (same merge as jj-vip.js), used when the
    // /cart.js refetch fails so the cart icon never drops to 0.
    const mergeAdded = (previous, addedItems) => {
      const addedKeys = new Set(addedItems.map((item) => item.key));
      const items = [...addedItems, ...(previous?.items || []).filter((item) => !addedKeys.has(item.key))];
      const sum = (field) => addedItems.reduce((total, item) => total + (Number(item[field]) || 0), 0);
      return {
        ...(previous || {}),
        items,
        item_count: items.reduce((total, item) => total + (Number(item.quantity) || 0), 0),
        total_price: (Number(previous?.total_price) || 0) + sum('final_line_price'),
        original_total_price: (Number(previous?.original_total_price) || 0) + sum('original_line_price'),
        items_subtotal_price: (Number(previous?.items_subtotal_price) || 0) + sum('final_line_price'),
      };
    };

    class JJMembershipCard extends HTMLElement {
      connectedCallback() {
        const days = parseInt(this.dataset.trialDays ?? '7', 10);
        this.trialDays = Number.isNaN(days) ? 7 : Math.max(0, days);
        this.busy = false;
        this.button = this.querySelector('[data-jj-join]');
        this.status = this.querySelector('[data-jj-status]');
        this.bagLinks = Array.from(this.querySelectorAll('[data-jj-open-bag]'));
        this.applyMemberStatus();
        this.updateDates();
        this.button?.addEventListener('click', this.onJoin);
        this.bagLinks.forEach((el) => el.addEventListener('click', this.onOpenBag));
        document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onJoin);
        this.bagLinks?.forEach((el) => el.removeEventListener('click', this.onOpenBag));
        document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      get variantId() {
        const fromSettings = (this.dataset.variantId || '').trim();
        if (fromSettings) return fromSettings;
        return String(readVipConfig()?.membershipVariantId || '').trim();
      }

      // The cart logic (jj-vip.js) adds a trial line to every cart with a Vault piece unless it knows the
      // shopper is a member. Only when #jj-vip-config carries a boolean customerIsMember does the card
      // follow it and show the member "Go to the Vault" button; otherwise that button stays hidden.
      applyMemberStatus() {
        const cfg = readVipConfig();
        const memberAware = typeof cfg?.customerIsMember === 'boolean';
        if (memberAware) {
          if (cfg.customerIsMember) {
            this.dataset.state = 'member';
          } else if (this.dataset.state === 'member') {
            this.dataset.state = this.dataset.inCart === 'true' ? 'in-cart' : 'join';
          }
        }
        this.querySelectorAll('[data-jj-member-cta]').forEach((el) => {
          el.hidden = !memberAware;
        });
      }

      get cartUrl() {
        return this.dataset.cartUrl || '/cart';
      }

      get cartAddUrl() {
        const base = this.dataset.cartAddUrl || '/cart/add';
        return base.endsWith('.js') ? base : `${base}.js`;
      }

      updateDates() {
        const date = new Date();
        date.setDate(date.getDate() + this.trialDays);
        this.querySelectorAll('[data-jj-first-charge]').forEach((el) => {
          el.textContent = formatDate(date);
        });
      }

      // Switches the visible action pane. Focus never stays on a control that the switch hides: it moves
      // to the new pane's title (tabindex -1) or its first link, so the cart drawer also returns focus there.
      setState(state, moveFocus = false) {
        if (this.dataset.state === 'member' || !state) return;
        const previous = this.dataset.state;
        const active = document.activeElement;
        const activePane = active instanceof HTMLElement && this.contains(active) ? active.closest('.jj-mc__state') : null;
        this.dataset.state = state;
        const focusHidden = previous !== state && activePane && activePane.getAttribute('data-for') !== state;
        if (moveFocus || focusHidden) this.focusState(state);
      }

      focusState(state) {
        const pane = this.querySelector(`.jj-mc__state[data-for="${state}"]`);
        const target =
          pane?.querySelector('[data-jj-state-focus]') || pane?.querySelector('a[href]:not([hidden]), button');
        if (target instanceof HTMLElement) target.focus();
      }

      // aria-disabled instead of disabled: a disabled button loses focus, so keyboard and screen reader
      // users would land on <body> while the request runs.
      setBusy(busy) {
        this.busy = busy;
        if (!this.button) return;
        this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (busy) this.button.setAttribute('aria-disabled', 'true');
        else this.button.removeAttribute('aria-disabled');
      }

      showStatus(message, tone) {
        if (!this.status) return;
        this.status.textContent = message || '';
        if (tone) this.status.dataset.tone = tone;
        else delete this.status.dataset.tone;
      }

      hasMembership(items) {
        const id = this.variantId;
        if (!id || !Array.isArray(items)) return false;
        return items.some((item) => String(item.variant_id || item.id) === id);
      }

      applyItems(items) {
        if (!Array.isArray(items)) return;
        this.setState(this.hasMembership(items) ? 'in-cart' : 'join');
      }

      async getCart() {
        const response = await fetch(`${this.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`cart ${response.status}`);
        return response.json();
      }

      // Another tab, or a page restored from the back-forward cache, may show a stale bag.
      syncWithCart() {
        if (this.busy || !this.variantId) return;
        this.getCart()
          .then((cart) => this.applyItems(cart?.items))
          .catch(() => {});
      }

      onPageShow = (event) => {
        if (!event.persisted) return;
        this.updateDates();
        this.syncWithCart();
      };

      onVisibilityChange = () => {
        if (document.visibilityState !== 'visible') return;
        this.updateDates();
        this.syncWithCart();
      };

      openBag() {
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          if (!drawer.isOpen) drawer.open();
          return true;
        }
        if (window.Shopify?.actions?.openCart) {
          window.Shopify.actions.openCart();
          return true;
        }
        window.location.href = this.cartUrl;
        return false;
      }

      onOpenBag = (event) => {
        if (document.querySelector('theme-drawer#cart-drawer')) {
          event.preventDefault();
          this.openBag();
        }
      };

      onCartUpdate = (event) => {
        const promise = event?.promise;
        const refetch = () => {
          this.getCart()
            .then((cart) => this.applyItems(cart?.items))
            .catch(() => {});
        };
        if (promise && typeof promise.then === 'function') {
          promise
            .then((result) => {
              const items = result?.detail?.items;
              if (Array.isArray(items)) this.applyItems(items);
              else refetch();
            })
            .catch(refetch);
        } else {
          refetch();
        }
      };

      onJoin = async () => {
        if (this.busy) return;
        const variantId = this.variantId;
        if (!variantId) {
          this.showStatus(this.dataset.setupText, 'error');
          return;
        }

        this.setBusy(true);
        this.showStatus('');
        let deferred = null;

        try {
          const current = await this.getCart();
          if (this.hasMembership(current.items)) {
            this.setState('in-cart', true);
            this.openBag();
            return;
          }

          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);

          let LinesUpdateEvent = null;
          try {
            const events = await import('@shopify/events');
            LinesUpdateEvent = events?.CartLinesUpdateEvent || null;
          } catch (error) {
            LinesUpdateEvent = null;
          }

          deferred =
            LinesUpdateEvent && typeof LinesUpdateEvent.createPromise === 'function'
              ? LinesUpdateEvent.createPromise()
              : null;
          const dispatched = Boolean(deferred);

          if (deferred) {
            this.dispatchEvent(
              new LinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: variantId, quantity: 1 }],
                promise: deferred.promise,
              })
            );
          }

          const response = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds.join(','),
            }),
          });
          const data = await response.json().catch(() => ({}));
          const failed = !response.ok || Boolean(data.status);

          let cart = await this.getCart().catch(() => null);
          if (!cart) {
            const added = Array.isArray(data.items) ? data.items : [];
            cart = failed || added.length === 0 ? current : mergeAdded(current, added);
          }

          if (deferred) {
            let eventCart = null;
            try {
              eventCart =
                typeof LinesUpdateEvent.createCartFromAjaxResponse === 'function'
                  ? LinesUpdateEvent.createCartFromAjaxResponse(cart)
                  : null;
            } catch (error) {
              eventCart = null;
            }
            deferred.resolve({
              cart: eventCart,
              detail: {
                items: cart.items,
                itemCount: cart.item_count,
                sections: failed ? undefined : data.sections,
                source: 'jj-membership-card',
                sourceId: this.id,
                didError: failed,
              },
            });
            deferred = null;
          }

          if (failed) {
            this.showStatus(data.description || data.message || this.dataset.errorText, 'error');
            return;
          }

          this.setState('in-cart', true);

          if (!dispatched) {
            window.location.href = this.cartUrl;
            return;
          }

          requestAnimationFrame(() => this.openBag());
        } catch (error) {
          console.warn('[jj-membership-card]', error);
          deferred?.reject(error);
          this.showStatus(this.dataset.errorText, 'error');
        } finally {
          this.setBusy(false);
        }
      };
    }

    customElements.define('jj-membership-card', JJMembershipCard);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-vault-calendar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('jj-countdown') && customElements.get('jj-vault-calendar')) return;

    const pad = (n) => String(n).padStart(2, '0');

    const partsInZone = (date, timeZone) => {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
      const parts = {};
      formatter.formatToParts(date).forEach((part) => {
        parts[part.type] = part.value;
      });
      return {
        y: Number(parts.year),
        m: Number(parts.month),
        d: Number(parts.day),
        h: Number(parts.hour) % 24,
        mi: Number(parts.minute),
        s: Number(parts.second),
      };
    };

    // UTC timestamp of a wall-clock time in a given IANA time zone (handles DST).
    const zonedTimeToUtc = (y, m, d, h, mi, timeZone) => {
      const wanted = Date.UTC(y, m - 1, d, h, mi, 0);
      let guess = wanted;
      for (let i = 0; i < 3; i += 1) {
        const p = partsInZone(new Date(guess), timeZone);
        const seen = Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s);
        const diff = seen - wanted;
        if (diff === 0) break;
        guess -= diff;
      }
      return guess;
    };

    const monthName = (y, m) =>
      new Date(Date.UTC(y, m - 1, 15)).toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });

    const safeZone = (tz) => {
      try {
        new Intl.DateTimeFormat('en-US', { timeZone: tz });
        return tz;
      } catch (error) {
        return 'America/New_York';
      }
    };

    const resolveTarget = (tz, override) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/.exec((override || '').trim());
      if (match) {
        return zonedTimeToUtc(
          Number(match[1]),
          Number(match[2]),
          Number(match[3]),
          Number(match[4] || 0),
          Number(match[5] || 0),
          tz
        );
      }
      const now = partsInZone(new Date(), tz);
      const nextY = now.m === 12 ? now.y + 1 : now.y;
      const nextM = now.m === 12 ? 1 : now.m + 1;
      return zonedTimeToUtc(nextY, nextM, 1, 0, 0, tz);
    };

    class JJCountdown extends HTMLElement {
      connectedCallback() {
        this.tz = safeZone(this.dataset.tz || 'America/New_York');
        const epoch = Number(this.dataset.targetEpoch || 0);
        this.target = epoch > 0 ? epoch * 1000 : resolveTarget(this.tz, this.dataset.target);
        this.units = {
          d: this.querySelector('[data-unit="d"]'),
          h: this.querySelector('[data-unit="h"]'),
          m: this.querySelector('[data-unit="m"]'),
          s: this.querySelector('[data-unit="s"]'),
        };
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      // The accessible name says the time left in words; set only when it changes (once a minute at most).
      setLabel(text) {
        if (text && this.getAttribute('aria-label') !== text) this.setAttribute('aria-label', text);
      }

      tick() {
        const left = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
        if (left <= 0) {
          this.setAttribute('data-ended', '');
          this.setLabel(this.dataset.ariaEnded);
          window.clearInterval(this.timer);
          return;
        }
        this.removeAttribute('data-ended');
        const days = Math.floor(left / 86400);
        const hours = Math.floor((left % 86400) / 3600);
        const minutes = Math.floor((left % 3600) / 60);
        const seconds = left % 60;
        if (this.units.d) this.units.d.textContent = String(days);
        if (this.units.h) this.units.h.textContent = pad(hours);
        if (this.units.m) this.units.m.textContent = pad(minutes);
        if (this.units.s) this.units.s.textContent = pad(seconds);
        const timeLeft =
          days > 0
            ? `${days} ${this.dataset.ariaDays || 'days'} ${hours} ${this.dataset.ariaHours || 'hours'}`
            : `${hours} ${this.dataset.ariaHours || 'hours'} ${minutes} ${this.dataset.ariaMinutes || 'min'}`;
        const base = (this.dataset.ariaBase || '').trim();
        this.setLabel(base ? `${base} ${timeLeft}` : timeLeft);
      }
    }

    // Only names Liquid took from the clock carry data-jj-month; metafield names are never touched.
    class JJVaultCalendar extends HTMLElement {
      connectedCallback() {
        const tz = safeZone(this.dataset.tz || 'America/New_York');
        const now = partsInZone(new Date(), tz);
        const prevY = now.m === 1 ? now.y - 1 : now.y;
        const prevM = now.m === 1 ? 12 : now.m - 1;
        const nextY = now.m === 12 ? now.y + 1 : now.y;
        const nextM = now.m === 12 ? 1 : now.m + 1;
        const names = {
          drop: monthName(now.y, now.m),
          vault: monthName(prevY, prevM),
          next: monthName(nextY, nextM),
        };
        this.querySelectorAll('[data-jj-month]').forEach((el) => {
          const key = el.getAttribute('data-jj-month');
          if (names[key]) el.textContent = names[key];
        });

        const source = this.dataset.source || 'clock';
        let refreshText = '';
        if (source === 'metafield') {
          const epoch = Number(this.dataset.targetEpoch || 0);
          if (epoch > 0) {
            const at = partsInZone(new Date(epoch * 1000), tz);
            refreshText = `${monthName(at.y, at.m)} ${at.d}`;
          }
        } else if (source === 'clock') {
          refreshText = `${names.next} 1`;
        }
        if (refreshText) {
          this.querySelectorAll('[data-jj-refresh-date]').forEach((el) => {
            el.textContent = refreshText;
          });
        }
      }
    }

    if (!customElements.get('jj-countdown')) customElements.define('jj-countdown', JJCountdown);
    if (!customElements.get('jj-vault-calendar')) customElements.define('jj-vault-calendar', JJVaultCalendar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
